import { createAction, props } from '@ngrx/store';
import { ModelChangeType } from '../../types/model-changed-types';

export interface FormChangeTypeAction {
  modelChangeType: ModelChangeType;
}

export const updateChangeType = createAction('UPDATE_CHANGE_TYPE', props<FormChangeTypeAction>());
